import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Container from '../Container';
import Heading from '../Heading';
import Card from './Card';
import styles from './styles.module.css'
import { FaArrowRightLong,FaArrowLeftLong } from "react-icons/fa6";


const CaseStudy = () => {

    const caseStudyData = [
        {
            id:1,
            title:"Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            image_url:"/case/case-studies-v4.jpg",
            link:{
                title:"Read Case Study",
                url:"#!",
            }
        },
        {
            id:2,
            title:"Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            image_url:"/case/case-studies-v1.jpg",
            link:{
                title:"Read Case Study",
                url:"#!",
            }
        },
        {
            id:3,
            title:"Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            image_url:"/case/case-studies-v2.jpg",
            link:{
                title:"Read Case Study",
                url:"#!",
            }
        },
        {
            id:4,
            title:"Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            image_url:"/case/case-studies-v3.jpg",
            link:{
                title:"Read Case Study",
                url:"#!",
            }
        },
        {
            id:5,
            title:"Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            image_url:"/case/case-studies-v4.jpg",
            link:{
                title:"Read Case Study",
                url:"#!",
            }
        },
        {
            id:6,
            title:"Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
            image_url:"/case/case-studies-v5.jpg",
            link:{
                title:"Read Case Study",
                url:"#!",
            }
        }
    ]

    const SampleNextArrow = (props) => {
        const { onClick } = props;
        return (
            <div className={`${styles['slick-arrow']} ${styles['next']} d-flex align-items-center justify-content-center`} onClick={onClick}>
                <FaArrowLeftLong size={20}/>
            </div>
        );
    }

    const SlickPrevArrow = (props)  => {
        const {onClick } = props;
        return (
            <div className={`${styles['slick-arrow']} ${styles['prev']} d-flex align-items-center justify-content-center`} onClick={onClick}>
                <FaArrowRightLong size={20} />
            </div>
        );
    }

    const settings = {
        className: "center",
        centerMode: true,
        infinite: true,
        centerPadding: "60px",
        slidesToShow: 3,
        speed: 1000,
        nextArrow:<SlickPrevArrow />,
        prevArrow:<SampleNextArrow />,

        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerPadding: "0px",
                    centerMode: false,
                }
            }
        ]
    };

    return (
        <section className={`${styles['section-5']} py-5 bg-secondary-black`}>
            <Container className="py-0 py-lg-5">
                <div className="row align-items-center">
                    <div className="col-12">
                        <Heading 
                            heading={'Case Study'}
                        />                            
                    </div>                   
                </div>

                <div className='row mt-5 py-4'>
                    {caseStudyData.length > 0 && 
                        <Slider {...settings}>
                            {caseStudyData.map(item =>
                                <Card 
                                    key={item.id} 
                                    title={item.title}
                                    imageUrl={item.image_url}
                                    link={item.link}
                                />
                            )}
                        </Slider>
                    }                    
                </div>                
            </Container>
        </section>
    );
};

export default CaseStudy;